import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import * as LocalStorage from '../../../utils/localStorageHelper';
import * as UserActions from '../../../actions/userActions';
import * as GoogleMapApi from '../../../utils/googleApiHelper';

class UserAddresses extends Component {

  constructor(props) {
    super(props);
    this.state = {}

    this.addNewAddress = this.addNewAddress.bind(this);
    this.editAddress = this.editAddress.bind(this);
    this.deleteAddress = this.deleteAddress.bind(this);
  }

  render() {

    const {addresses} = this.props;
    return (
      <div className="row user-addresses-container">
        {addresses ? (
          addresses.map(address => {
            return (
              <div className="col-sm-6 col-md-6 col-xl-4" key={address._id}>
                <div className="user-address-card">
                  {/* <div className="address-header"></div> */}
                  <div className="address-content">
                    <p className="title">Address</p>
                  <p className="content">{address.apartment ? `Apartment #: ${address.apartment}, ${address.description}` : address.description}</p>
                  </div>
                  <div className="address-footer">
                    <ul>
                      <li>
                        <a href="javascript:void(0)" onClick={() => this.editAddress(address)}>Edit</a>
                      </li>
                      <li>
                        <a href="javascript:void(0)" onClick={() => this.deleteAddress(address)}>Delete</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )
          })
        ) : null}
        <div className="col-sm-6 col-md-6 col-xl-4">
          <div className="user-address-card default">
            <div className="content" onClick={() => this.addNewAddress()}>
              <i className="fa fa-plus-circle icon"></i>
              <div className="title">Add New Address</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  addNewAddress() {
    this.props.history.push({pathname:'/place-picker', state: {actionMode: 'add'}});
  }

  editAddress(address) {

    let loc = address.loc;
    console.log(address);
    if(address.loc && address.loc[0] && address.loc[1]) {
      GoogleMapApi.getPlaceByLatLng(address.loc[1], address.loc[0]).then(place => {
        console.log("PLACE_GET_BY_LAT_LNG", place);
        LocalStorage.put("edit_google_place", place);
        this.props.history.push({pathname:'/place-picker', state: {actionMode: 'edit', addressId: address._id,apartment:address.apartment}});
      }).catch(error => alert(error));
    } else {
      alert('Something went wrong!')
    }

  }

  deleteAddress(address) {

    const {onDeleteAddress} = this.props;
    if(onDeleteAddress) onDeleteAddress(address);
  }

}

export default UserAddresses;



// WEBPACK FOOTER //
// ./src/containers/settings/profile/Addresses.js